import { MarketplaceButtonAction } from './marketplace-button.action';
import { actionRules } from './marketplace-action.rules';
import { MarketplaceItemV2 } from '@fgb/core';

/**
 * Helper function for resolving the appropriate action for a marketplace item based on predefined rules.
 * It iterates through the action rules and returns the first matching action configuration, which includes a factory function to create the action instance and the label for the button.
 * If no rules match, it returns null, indicating that no action should be rendered for the item.
 * This function is used in the marketplace details component to determine which action button to display for each item.
 */
export function resolveMarketplaceAction(
  item: MarketplaceItemV2
): { create: () => MarketplaceButtonAction; label: string } | null {
  const matchedRule = actionRules.find((rule) => rule.when(item));
  if (!matchedRule) {
    return null;
  }

  return {
    create: matchedRule.create,
    label: matchedRule.label(item.ProcessProviderId),
  };
}
